import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { casinoDialogData, CasinoGameListModel, CasinoGameModel, goGamesApiType } from '@components/casino/casino.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CasinoHelper } from '@components/casino/casino.helper';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'casinoGame-dialog',
  templateUrl: './casinoGame.dialog.html',
})
export class CasinoGameDialog implements OnInit, OnChanges {
  safeHtmlContent: SafeHtml;
  gameType: string;
  isError = false;
  isSliderMenu = false;
  Subscription;
  constructor(private _CasinoHelper: CasinoHelper, private sanitizer: DomSanitizer) {}
  @Input() openGameData: goGamesApiType;
  @Input() openGameId: number;
  @Input() gameData: CasinoGameModel;
  @Input() providerData: CasinoGameListModel;
  @Output() closedGameModal: EventEmitter<number> = new EventEmitter<number>();
  ngOnInit() {
    this.casinoGamesAction();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.openGameId?.currentValue !== changes.openGameId?.previousValue) {
      this.casinoGamesAction();
    }
  }

  casinoGamesAction() {
    if (this.openGameData?.Success) {
      if (this.openGameData?.Type === 'html') {
        this.gameType = this.openGameData?.Type;
        this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.openGameData?.Data);
      } else if (this.openGameData?.Type === 'url') {
        this.gameType = this.openGameData?.Type;
        this.safeHtmlContent = this.sanitizer.bypassSecurityTrustResourceUrl(this.openGameData?.Data);
      } else if (this.openGameData?.Type === 'UrlRedirect') {
        this.gameType = this.openGameData?.Type;
        this.safeHtmlContent = this.sanitizer.bypassSecurityTrustResourceUrl(this.openGameData?.Data);
      } else if (this.openGameData?.Type === 'script') {
        if (this.gameData?.providerId === 9) {
          this.gameType = this.openGameData?.Type;
          this.injectScriptAsiaGaming();
        } else {
          this.gameType = this.openGameData?.Type;
          this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.openGameData?.Data);
          setTimeout(() => this.injectScript(), 0);
        }
      }
    } else {
      this.isError = true;
    }
  }

  injectScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = this.openGameData?.Data.match(/<script.*?>([\s\S]*?)<\/script>/)[1];
    document.body.appendChild(script);
  }

  injectScriptAsiaGaming() {
    const match = this.openGameData?.Data.match(/location.replace\("([^"]+)"\)/);
    if (match) {
      this.safeHtmlContent = this.sanitizer.bypassSecurityTrustResourceUrl(match[1]);
    }
  }

  dialogBottomBannerDataRebuild(gameData: CasinoGameListModel) {
    if (Array.isArray(gameData.gameList) && gameData.gameList.length > 20) {
      let cloneData = cloneDeep(gameData);
      cloneData.gameList = cloneData.gameList.slice(0, 20);
      return cloneData;
    } else {
      return gameData;
    }
  }

  closedModal() {
    this.closedGameModal.emit();
  }

  sliderMenuAction() {
    this.isSliderMenu = !this.isSliderMenu;
  }
}
